import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Joplin, MO?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a Joplin-area post office can take 2–6 months, especially during busy travel seasons. The nearest Regional Passport Agency is over 3 hours away in St. Louis, and appointments there are competitive. For Tri-State business travelers, agricultural trade professionals, and MSSU students, expedited processing through a registered courier is the reliable option.",
  },
  {
    q: "Do I have to drive to St. Louis to get an expedited passport from Joplin?",
    a: "No — that is precisely what Fast Passport Center eliminates. The St. Louis Passport Agency is 3+ hours from Joplin, and getting a non-emergency appointment there is not guaranteed. We provide reserved courier submission that lets you start online, ship your documents overnight from the Joplin FedEx or UPS, and receive your passport within the timeframe you select. No road trip to St. Louis required.",
  },
  {
    q: "Can MSSU students get a passport fast for study abroad?",
    a: "Yes. Missouri Southern State University students who receive study-abroad program acceptance often discover they need expedited passport service quickly. Many MSSU students are first-time applicants who need to visit an acceptance clerk in Joplin first — we guide you through the exact location, forms, and process so you don't miss your program orientation. Expedited processing is available after the clerk visit.",
  },
  {
    q: "What about cross-border business travel to Mexico or Canada?",
    a: "Mexico and Canada cross-border business travel is one of the most common passport urgencies in the Joplin area. Agricultural trade travel, manufacturing supplier visits, and Tri-State business meetings often book on short notice — especially when commodity prices move. We regularly process expedited passports for Joplin-area business travelers with departure windows of 1–2 weeks. Start your order as soon as travel is confirmed.",
  },
  {
    q: "Can Tri-State travelers in Kansas and Oklahoma use Fast Passport Center?",
    a: "Absolutely. Fast Passport Center serves the entire Tri-State region — Joplin, MO; Pittsburg, KS; Miami, OK; and all surrounding communities. Our service is fully remote: start online, ship documents overnight from any UPS or FedEx location in the region, and we handle the expedited processing. Your location in the Tri-State area does not affect processing speed or availability.",
  },
  {
    q: "What if I live in Carthage or Webb City — can you still help?",
    a: "Yes — Carthage, Webb City, Carl Junction, Neosho, and all Jasper County communities are fully within our service area. You can ship overnight from the Carthage Post Office, Webb City UPS, or any carrier location in Newton County. Most clients in the greater Joplin area receive their passports within 2–9 business days depending on the processing option selected.",
  },
  {
    q: "What documents do I need for an expedited passport?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required for your specific situation.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
];

export default function JoplinFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Joplin and Tri-State travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden">
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i className={`text-white text-sm transition-transform duration-200 ${openIndex === i ? "ri-subtract-line" : "ri-add-line"}`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}